<template v-bind:is="currentTabComponent" >

     <spinner v-if="!loaded" ></spinner>

    <div class="" v-else-if="loaded" >
        <ul class="horizontal-menu font-size-16" >
            
            <li>
                <router-link :to="{name: 'Account'}" > Account </router-link>
            </li>
            
            <li class="d-none" >
                <router-link :to="{name: 'Pricing'}" > Pricing </router-link>
            </li>
            
            <!--
            <li v-if="userRole <= 2" >
                <router-link :to="{name: 'Users'}" > Users </router-link>
            </li>
            -->

            <li class="" >
                <router-link :to="{name: 'Billing'}" > Billing </router-link>
            </li>
            
        </ul>
        
        <div class="" > 
            <router-view></router-view>
        </div>
    </div>

</template>

<script>

import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
import jwt_decode from "jwt-decode";

export default {
    name: 'settingsPage',
    props: {
        
        
    },
    data: function(){
        return {
            pagetitle: "Settings",
            loaded: false
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted() {
        
        this.loaded = true;
    },
    beforeDestroy() {
    },
    methods: {

    },
    computed: {
        userRole(){
            //return this.$store.getters.getRole
            //let user = JSON.parse( atob( Cookies.get('user') ) )
            let user = jwt_decode(Cookies.get('user-token'))
            console.log(user.data.role)
            return user.data.role
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

</style>



// WEBPACK FOOTER //
// src/templates/settings/Settings.vue